import { langSegment } from '@tmf-ui-routes/i18n-segments/lang-segment.i18n-segment';

export function homeRoutePath(): string {
  return `/${langSegment()}/`;
}
